function CartWatcher () {
  console.clear();

  Shopify.Cart = Shopify.Cart || {};
  Shopify.Cart.Actions = {};

  const checkoutButton = document.querySelector('[type="submit"][name="checkout"]');

  if (!checkoutButton) return;
  
  const cartForm = document.querySelector('form[action="/cart"]');
  const cartTable = cartForm?.querySelector('.cart-table') || cartLineItems?.closest('table');

  // メッセージの親要素
  const messageContainer = document.querySelector('[data-cart-messages-important]');
  
  // エラー時に非表示にする要素
  const selectorsHideOnError = ['[data-cart-option-gift-wrap]', '[data-cart-messages-other]', '[data-cart-attributes]'];
  const elementsToHideOnError = document.querySelectorAll(selectorsHideOnError.join(','));

  const giftWrappingBox = document.querySelector('[data-cart-option-gift-wrap]');

  // カートページでなければ中止
  if (!cartForm || !cartTable) return;

  // カートテーブル内 個々の商品
  const cartLineItems = document.querySelector('[data-cart-line-items]');

  // 会計以外のボタン
  const additionalCTAs = document.querySelector('.additional-checkout-buttons');

  // ハンドル (URL に変更があったらここを変更)
  const GIFT_WRAP_HANDLE_DEFAULT = 'gift-wrapping';
  const GIFT_WRAP_HANDLE_ENGRAVE = 'gift-wrapping-engrave';

  // [FLAGS]
  const Condi = {
    canCheckout: true,
    hasEngraveItems: false,
    hasRegularWrapping: false,
    hasMixedItems: false,
    isTermAccepted: false,
    hasGiftWrapping: false,
    hasOnlyGiftWrap: false,
  };

  const engraveOptionTexts = document.querySelector('#engrave-option-texts');
  const engraveOptionMessage = document.querySelector('[data-engrave-option-message]');

  const Notify = {
    // elements の定義を変更
    // { type: { element: HTMLElement, container: HTMLElement } }
    elements: {}, 

    /**
     * メッセージ要素を初期化・登録する
     * @param {body} type messages のキー
     * @param {HTMLElement} container メッセージを挿入する親要素
     */
    register(type, container) {
        const msg = messages[type];
        if (!msg || !container) {
          console.warn(`Message type ${type} or container not found for registration.`);
          return;
        }

        // すでに登録済みならスキップ
        if (this.elements[type]) {
          console.warn(`Message type ${type} already registered.`);
          return;
        }

        // 要素を生成
        const el = document.createElement('div');
        el.id = msg.id;
        el.className = `callout callout:${msg.color}`;
        el.innerHTML = `<div class="callout-text">${msg.body}</div>`;
        
        // 初期状態では非表示にしておく
        el.style.display = 'none';

        // container の直後に要素を挿入
        container.appendChild(el);

        // 登録
        this.elements[type] = {
          element: el,
          container: container // container は参照として保持しても良いが、今回は element があれば事足りる
        };
    },

    /**
     * メッセージを表示する（container 不要）
     * @param {body} type messages のキー
     */
    show(type) {
        const entry = this.elements[type];
        // 登録済みでない場合は何もしない
        if (!entry) {
          console.warn(`Message type ${type} is not registered. Call register() first.`);
          return;
        }
        entry.element.style.display = 'block';
    },

    /**
     * メッセージを非表示にする
     * @param {body} type messages のキー
     */
    hide(type) {
      const entry = this.elements[type];
      if (entry) {
        entry.element.style.display = 'none';
      }
    },

    // 全てのメッセージを非表示にする
    hideAll() {
      Object.values(this.elements).forEach(entry => {
        entry.element.style.display = 'none';
      });
    }
  };

  const messages = {
    'mixedItems': {
      id: 'cart-engrave-option-warning-mixed-item',
      title: '',
      body: engraveOptionTexts?.dataset.warningMixedItem || '',
      color: 'red',
    },
    'mixedGiftWrap': {
      id: 'cart-mixed-gift-wrappings',
      title: '',
      body: '<b>種類の異なるギフトラッピングが混在しています</b><br>[刻印オプション + 刻印専用ギフトラッピング] または [通常商品 + 通常のギフトラッピング] の組み合わせでご利用いただけます。通常商品との同時購入はできません。',
      color: 'red',
    },
    'wongGiftWrap': {
      id: 'cart-wrong-gift-wrapping',
      title: '',
      body: '<b>対応していないギフトラッピングがあります。</b>通常商品は通常のギフトラッピング、刻印サービス商品等は専用のギフトラッピングのみご利用いただけます。お手数ですが一度カートよりギフトラッピングを削除してください。',
      color: 'red',
    },
    'hasOnlyGiftWrap': {
      id: 'cart-only-gift-wrapping-in-cart',
      title: '',
      body: '<b>ギフトラッピングのみのご購入はできません。</b>カートより削除いただくか、商品を追加してください。',
      color: 'red',
    },
  };

  if (messageContainer) {
    for (const [key, value] of Object.entries(messages)) {
      Notify.register(key, messageContainer);
    }
  }

  function disableCheckout (message = '') {
    console.log('[CART] × 購入無効化: ' + message);
    checkoutButton.style.setProperty('pointer-events', 'none');
    checkoutButton.style.setProperty('opacity', '50%');
    checkoutButton.style.setProperty('background-color', 'gray');
    checkoutButton.disabled = true;
    elementsToHideOnError.forEach(elm => elm?.style.setProperty('display', 'none'));
    additionalCTAs?.style.setProperty('display', 'none');
  }

  function enableCheckout () {
    console.log('%c[CART] ✔︎ 購入可能です', 'color: lime');
    elementsToHideOnError.forEach(elm => elm?.style.removeProperty('display'));
    checkoutButton.style.removeProperty('pointer-events');
    checkoutButton.style.removeProperty('opacity');
    checkoutButton.disabled = false;
    checkoutButton.style.removeProperty('background-color');
    additionalCTAs?.style.removeProperty('display');
    document.body.classList.remove('mixed-cart-warning-shown');
  }

  // 購入可能かどうか判定
  function evalutate () {

    // [NG パターン定義]
    // * 刻印商品と通常商品
    // * 刻印商品と通常のギフトラッピング
    // * 通常商品と専用のギフトラッピング
    // * 種類のことなるギフトラッピング
    // * ギフトラッピングだけ

    Condi.canCheckout = true; // 初期 true とし, いずれかの NG 条件に引っ掛かったら false にする

    // 刻印商品があるか
    if (Condi.hasEngraveItems) {
      document.body.classList.add('cart-contains-gpo-items');
    } else {
      document.body.classList.remove('cart-contains-gpo-items');
    }

    // * 刻印商品と通常商品
    if (Condi.hasMixedItems) {
      Condi.canCheckout = false;
      Notify.show('mixedItems');
    } else {
      Notify.hide('mixedItems');
    }

     // * 刻印商品と通常ギフトラッピング または
     // * 通常商品と刻印専用ギフトラッピング
    if (
      (Condi.hasEngraveItems && Condi.hasRegularWrapping) || 
      (Condi.hasRegularItem && Condi.hasEngraveWrapping)
    ) {
      Condi.canCheckout = false;
      Notify.show('wongGiftWrap');
    } else {
      Notify.hide('wongGiftWrap');
    }    

    // * 種類のことなるギフトラッピング
    if (Condi.hasRegularWrapping && Condi.hasEngraveWrapping) {
      Condi.canCheckout = false;
      Notify.show('mixedGiftWrap');
    } else {
      Notify.hide('mixedGiftWrap');
    }

    // * ギフトラッピングしかない
    if (Condi.hasOnlyGiftWrap){
      Condi.canCheckout = false;
      Notify.show('hasOnlyGiftWrap');
    } else {
      Notify.hide('hasOnlyGiftWrap');
    }

    // 最後, チェックアウト条件をクリアしているかチェック
    if (Condi.canCheckout) {
      enableCheckout();
    } else {
      disableCheckout();
    }
  }

  function checkCartItems () {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const itemCount = cart.items.length;

        if (itemCount == 0) return;

        // 刻印商品があるか
        const EngraveItems = cart.items.filter(item => item.properties && item.properties['刻印']);
        Condi.hasEngraveItems = EngraveItems.length > 0;

        // 通常商品があるか (刻印商品でもギフトラッピングでもないもの)
        Condi.hasRegularItem = cart.items.some(item => {
          const isEngraveItem = item.properties && item.properties['刻印'];
          const isGiftWrap = item.handle.includes(GIFT_WRAP_HANDLE_DEFAULT);
          return !isEngraveItem && !isGiftWrap; 
        });
        
        // 通常商品と刻印商品が混在しているか
        Condi.hasMixedItems = Condi.hasEngraveItems && Condi.hasRegularItem;

        // 通常ギフトラッピングがあるか
        Condi.hasRegularWrapping = cart.items.some(item => {
          return item.handle == GIFT_WRAP_HANDLE_DEFAULT;
        });

        // 専用ギフトラッピングがあるか
        Condi.hasEngraveWrapping = cart.items.some(item => {
          return item.handle == GIFT_WRAP_HANDLE_ENGRAVE;
        });
      
        // ギフトラッピングがあるか
        Condi.hasGiftWrapping = Condi.hasRegularWrapping || Condi.hasEngraveWrapping;

        // 異なるギフトラップが混在しているか
        Condi.hasMixedGiftWrapping = Condi.hasRegularWrapping && Condi.hasEngraveWrapping;

        // ギフトラッピングしかないか
        Condi.hasOnlyGiftWrap = itemCount == 1 && Condi.hasGiftWrapping;

        // 購入ボタンの制御
        evalutate();
      });
  }

  function observeCartChanges () {
    if (!cartLineItems) return;

    const observer = new MutationObserver(() => {
      console.log('カート内容が変更されました');
      checkCartItems();
    });

    observer.observe(cartLineItems, {
      childList: true,
      subtree: true
    });
  };

  checkCartItems();
  observeCartChanges();
}

document.addEventListener('DOMContentLoaded', () => {
  CartWatcher();
});